import React from 'react'
import { HelmetFunc } from 'components/PageMetaData'
import { ExamplesOfProjects } from 'blocks/ExamplesOfProjects'
import { RunningLine } from 'components/RunningLine'
import { useTranslation } from 'react-i18next'
import { Layout } from 'layout/Layout'
import { DefaultFormBlock } from 'blocks/DefaultFormBlock'
import styled from 'styled-components'
import { backgroundColors, colors } from 'styles/colors'
import { mobileAfterBorder } from 'styles/mobileAfterBorder'
import { displayWidth } from 'styles/width'
import { Container } from 'components/Container'
import { IconListQuestion } from 'components/IconListQuestion'
import { graphql } from 'gatsby'
import { getDataByLanguage } from 'utils/getDataByLanguage'
import { LeftSidebar, RightSidebar } from 'components/SideBar'
import { IItem } from 'types/interfaces'
import { ExamplesOfProjectsHome } from 'blocks/ExamplesOfProjectsHome'
import { searchStringToObject } from 'use-query-params'

const pageMetadata = {
    uk: {
        title:
            'Зразки дизайн проектів інтер`єру квартири та приватного будинку',
        description:
            'Дизайн-проект містить усі креслення для планування, складання кошторису, виконання ремонту та підбору меблів.',
    },
    ru: {
        title: 'Образцы дизайн проектов интерьера квартиры и частного дома',
        description:
            'Дизайн-проект содержит все чертежи для планировки, составления сметы, выполнения ремонта и подбора мебели',
    },
    en: {
        title: 'Samples of apartment and house interior design projects',
        description:
            'The design project contains all the drawings for planning, costing, repairs and furniture selection.',
    },
}

const ProjectStructureWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    position: relative;
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: 1px solid ${colors.dark};
    }
    ${mobileAfterBorder}
`

const IconListStyled = styled(IconListQuestion)`
    background-color: ${(props) =>
        props.background || backgroundColors.contact};
    border-bottom: 1px solid ${colors.dark};
    h2 {
        font-size: 30px;
        line-height: 35px;
    }
    @media (min-width: ${displayWidth.tablet}) {
        border-bottom: none;
    }
`
const ExamplePage = ({
    data,
    location,
}: {
    data: {
        allProjectStructureDesignYaml: { items: IItem }
        allExampleFaqYaml: { items: IItem }
    }
    location: { search: string }
}) => {
    const { t, i18n } = useTranslation()
    const queryParams = searchStringToObject(location.search)
    const shouldOpenModal = queryParams.openModal?.includes('true')

    const projectStructureData = getDataByLanguage(
        data.allProjectStructureDesignYaml,
        i18n.language
    )

    const faqData = getDataByLanguage(data.allExampleFaqYaml, i18n.language)

    return (
        <Layout>
            <HelmetFunc data={pageMetadata} />
            <ExamplesOfProjects priceText="" />
            <RunningLine>{t('designProject99')}</RunningLine>
            <ExamplesOfProjectsHome
                withH2Header
                autoOpenModal={shouldOpenModal}
            />
            <ProjectStructureWrapper>
                <LeftSidebar background={backgroundColors.project} />
                <Container columns={'1fr'} tabletColumns={'1fr'}>
                    <IconListStyled
                        items={faqData.items}
                        fill={colors.accentText}
                        background={backgroundColors.project}
                    />
                </Container>
                <RightSidebar />
            </ProjectStructureWrapper>
            <RunningLine>{t('designProject99')}</RunningLine>
            <ProjectStructureWrapper>
                <LeftSidebar background={backgroundColors.index} />
                <Container columns={'1fr'} tabletColumns={'1fr'}>
                    <IconListStyled
                        items={projectStructureData.items}
                        fill={colors.blue}
                    />
                </Container>
                <RightSidebar />
            </ProjectStructureWrapper>
            <DefaultFormBlock
                withPhoneMobile
                tracking={{
                    conversionType: 'FormExample',
                    eventCategory: 'FormExample',
                }}
            />
        </Layout>
    )
}

export default ExamplePage

export const query = graphql`
    query {
        allProjectStructureDesignYaml {
            edges {
                node {
                    items {
                        question
                        answer
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
        allExampleFaqYaml {
            edges {
                node {
                    items {
                        question
                        answer
                    }
                    parent {
                        ... on File {
                            name
                        }
                    }
                }
            }
        }
    }
`
